import { ImageCheck, LoadingSimpleComponent } from "Admin/Components";
import { formItemLayout } from "Admin/Config/FormLayout";
import { ImageCheckType, SkeletonType } from "Admin/Config/ImageType";
import { getProfileSummary, updateProfileSummary } from "Admin/Service/Profile";
import { Button, Form, Input, message, Tag } from "antd";
import { useEffect, useState } from "react";
import { handleAPIResponse } from "SuperAdmin/Utils/HandleAPIResponse";
import styles from "./Summary.module.scss";
const Summary = () => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(true);
  const name = Form.useWatch("name", form);
  const phone = Form.useWatch("phone", form);
  const position = Form.useWatch("position", form);
  const biography = Form.useWatch("biography", form);
  const homepage = Form.useWatch("homepage", form);
  useEffect(() => {
    setIsLoading(true);
    getProfileSummary((res) => {
      handleAPIResponse(res, () => {
        form.setFieldsValue(res.data);
        setIsLoading(false);
      });
    });
  }, []);

  const onFinishForm = () => {
    const payload = {
      name: name,
      phone: phone,
      position: position,
      bio: biography,
      homepage: homepage,
    };
    updateProfileSummary(payload, (res) => {
      handleAPIResponse(res, () => {
        message.success("Update profile successully");
      });
    });
  };
  return (
    <div className={styles["summary"]}>
      <div className={styles["avatar"]}>
        <LoadingSimpleComponent
          component={
            <ImageCheck
              url={form.getFieldValue("photo_url")}
              alt={"avatar"}
              type={ImageCheckType.FACULTY_AVATAR}
              classname={styles["avatar"]}
            />
          }
          type={SkeletonType.IMAGE}
          isLoading={isLoading}
        />
      </div>
      <div className={styles["information-form"]}>
        <Form
          {...formItemLayout}
          form={form}
          onFinish={onFinishForm}
          layout="vertical"
        >
          <Form.Item
            rules={[
              {
                required: true,
              },
            ]}
            label={"Name:"}
            labelAlign="left"
            name="name"
          >
            <Input placeholder="Please input the name" />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
              },
            ]}
            label={"Email:"}
            labelAlign="left"
            name="email"
          >
            <Input placeholder="Please input the email" disabled />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
              },
            ]}
            label={"Institution:"}
            labelAlign="left"
            name="institution"
          >
            <Input placeholder="Please input the institution" disabled />
          </Form.Item>
          <Form.Item label={"Phone:"} labelAlign="left" name="phone">
            <Input placeholder="Please input the email" />
          </Form.Item>
          <Form.Item
            label={"Departments:"}
            labelAlign="left"
            name="departments"
          >
            {form.getFieldValue()?.departments?.map((item, index) => {
              return (
                <Tag color="geekblue" key={index}>
                  {item}
                </Tag>
              );
            })}
          </Form.Item>
          <Form.Item label={"Position:"} labelAlign="left" name="position">
            <Input placeholder="Please input the position" />
          </Form.Item>
          <Form.Item label={"Biography:"} labelAlign="left" name="biography">
            <Input.TextArea rows={6} placeholder="Please input the biography" />
          </Form.Item>
          <Form.Item label={"Home page:"} labelAlign="left" name="homepage">
            <Input placeholder="Please input the personal page" />
          </Form.Item>
          <div className={styles["update-button"]}>
            <Button htmlType="submit" type="primary">
              Update
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Summary;
